module.exports = __webpack_public_path__ + "img/3.dc92a80e.png";